import React, { useEffect, useState, useCallback, memo } from 'react';
import { useCapsuleConfigurator } from '../../../../context/CapsuleConfiguratorContext';
import api from '../../../../middleware/api';
import { toast } from 'react-toastify';
import { useOutletContext } from 'react-router-dom';

const DilutionCell = ({ value, row, table }) => {
  const { setData: updateCustomerData } = useOutletContext()
  const { dilutions, selectedConfigurationId, capsuleConfiguration, defaultCapsule, synchronizeConfigurations } = useCapsuleConfigurator()
  const [isLoading, setIsLoading] = useState(false);

  // Récupérer la propriété isInitialConfiguration depuis les meta options de la table
  // Si isInitialConfiguration est true, cela signifie qu'on ne peut pas modifier les dilutions
  const isDisabled = table.options.meta.isInitialConfiguration || isLoading;

  const handleChange = useCallback((event) => {
    // Ne rien faire si on est sur une configuration non-initiale ou en cours de chargement
    if (isDisabled) return;

    if (row.original.dilution && row.original.dilution.id === event.target.value) return
    const dilution = dilutions.values.find(dilution => dilution.id === parseInt(event.target.value))
    if (!dilution) return
    updateDilution(dilution)
  }, [isDisabled, row.original.dilution, dilutions, row.original.mixture.id]);

  const updateDilution = async (dilution) => {
    setIsLoading(true);
    
    try {
      const index = capsuleConfiguration.content.findIndex(content => content.mixture.id === row.original.mixture.id)
      const response = await api.put(`/capsules/configurations/update/content`, {
        configurationId: selectedConfigurationId,
        property: 'dilution',
        index: index,
        newValue: dilution
      })
      console.log(row.index)
      if (response.status === 200) {
        table.options.meta.updateColumnWithMixtureId(row.original.mixture.id, 'dilution', dilution);
        synchronizeConfigurations(response.data.configurations);

      } else {
        toast.error('Erreur lors de la mise à jour de la dilution');
      }
    } catch (error) {
      toast.error('Erreur de connexion');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    // Default Dilution = row.original.mixture.defaultDilution.id
    // If row.original.dilution is empty, set it to defaultDilution
    if (dilutions && !row.original.dilution && row.original.mixture.defaultDilution) {
      const dilution = dilutions.values.find(dilution => dilution.id === row.original.mixture.defaultDilution.id)
      table.options.meta.updateColumnWithMixtureId(row.original.mixture.id, 'dilution', dilution);
    }
  }, [dilutions]);

  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-base-100/50 z-10">
          <span className="loading loading-spinner loading-sm text-primary"></span>
        </div>
      )}
      <select
        className={`select select-sm select-primary select-ghost w-full max-w-xs p-1 items-center leading-none ${isDisabled ? 'opacity-70 cursor-not-allowed' : ''}`}
        value={value || ''}
        onChange={handleChange}
        disabled={isDisabled}
      >
        {dilutions && dilutions.values.map(option => {
          return (
            <option className='dropdown-content' key={option.id} value={option.id}>
              {option.label}
            </option>
          )
        }
        )}
      </select>
    </div>
  );
};

// Utiliser memo pour éviter les re-renders inutiles
export default memo(DilutionCell, (prevProps, nextProps) => {
  // Ne re-render que si la valeur a changé ou si la ligne a changé
  return prevProps.value === nextProps.value && prevProps.row.id === nextProps.row.id;
});
